import { useEffect } from "react";

import ConfirmedBingoOverlay from "./ConfirmedBingoOverlay";
import { useBingoGameStore } from "@/plugins/bingo/state/bingoGameStore";

/**
 * ConfirmedBingoLiveOverlay — projector-facing wrapper that reads
 * confirmedBingo state from the game store and hands it to the
 * presentational overlay.
 *
 * Also owns the auto-dismiss timer (~10s) so the show smoothly
 * returns to the bingo board even if the host forgets to click
 * Continue. The host can dismiss earlier from their panel.
 */
const AUTO_DISMISS_MS = 10000;

export default function ConfirmedBingoLiveOverlay() {
  const confirmedBingo = useBingoGameStore((s) => s.confirmedBingo);
  const dismiss = useBingoGameStore((s) => s.dismissConfirmedBingo);

  // Only the HOST auto-dismisses (the Projector receives the event via
  // sync). We detect "am I the host?" by whether dismissConfirmedBingo
  // actually publishes — but here we just guard by presence of the
  // action. Both windows have it, so we defer to the Host's publish/receive
  // pattern: the Host store's setTimeout will fire and publish
  // CONFIRMED_BINGO_DISMISSED which both windows receive.
  useEffect(() => {
    if (!confirmedBingo) return;
    const t = setTimeout(() => {
      // If still active, dismiss. This is idempotent — dismiss() no-ops
      // when confirmedBingo is already null.
      dismiss();
    }, AUTO_DISMISS_MS);
    return () => clearTimeout(t);
  }, [confirmedBingo, dismiss]);

  return (
    <ConfirmedBingoOverlay
      active={!!confirmedBingo}
      name={confirmedBingo?.name}
      stageLabel={confirmedBingo?.stageLabel}
    />
  );
}
